<template>
  <div class="header">
    <!-- 상단 로고 영역 -->
    <div id="fixed_header" :class="['logo_wrap_01', { on: isScrolled }]">
      <div class="width_wrap">
        <div class="btn_wrap">
          <ul v-if="!isLoggedIn">
            <!-- <li style="margin-right: 5px">
              <router-link :to="`${USER_ROUTES.Login.Path}`" alt="로그인"
                >로그인</router-link
              >
            </li> -->
            <li style="margin-right: 5px">
              <router-link :to="`${USER_ROUTES.Join.Path}`" alt="개인·회원가입"
                >개인·회원가입</router-link
              >
            </li>
            <li>
              <router-link
                :to="`${USER_ROUTES.RequestOrgRegist.Path}`"
                alt="기관·신규등록신청"
                >기관·신규등록신청</router-link
              >
            </li>
          </ul>
          <!-- 로그인 시 -->
          <ul v-if="isLoggedIn">
            <li style="margin-right: 5px">
              <a href="#" @click.prevent="handleLogout">로그아웃</a>
            </li>
            <li>
              <router-link
                v-if="isOrgUser || isOrgAdmin"
                :to="`${USER_ROUTES.Mypage.Order.Org.Path}`"
                alt="마이페이지"
                >마이페이지</router-link
              >
              <router-link
                v-else
                :to="`${USER_ROUTES.Mypage.Order.Personal.Path}`"
                alt="마이페이지"
                >마이페이지</router-link
              >
            </li>
          </ul>
        </div>
        <!-- 로고 간편디자인 -->
        <h1>
          <router-link :to="`${USER_ROUTES.Home.Path}`"
            ><img
              src="@/assets/img/logo-11739509362.png"
              style="vertical-align: middle; border: 0"
              alt=""
              title=""
          /></router-link>
        </h1>
        <!-- //로고 간편디자인 -->

        <!-- pc 메뉴 -->
        <div class="pc_nav dis_tablet_desktop">
          <!-- ***템플릿 호환가능*** (phpx 변수관리 추가 해주세요)-->

          <div id="pm_pc_nav_02" class="pm-navigation_horizon_pc_nav_02">
            <!-- 1 Depth -->
            <ul class="dep1">
              <li
                role="toggle"
                :class="{ on: $route.path.includes(USER_ROUTES.Intro.Path) }"
              >
                <!-- TODO: hover 시 배경 색상 변경 필요 -->
                <n-dropdown
                  trigger="hover"
                  placement="bottom-start"
                  :options="createXOpt"
                  @select="handleSelect"
                  class="custom-dropdown-style"
                >
                  <router-link :to="`${USER_ROUTES.Intro.Path}`"
                    >CreateX소개
                  </router-link>
                </n-dropdown>
              </li>
              <li
                role="toggle"
                :class="{
                  on:
                    $route.path.includes(
                      USER_ROUTES.Product.Testing.Putt.Path
                    ) ||
                    $route.path.includes(
                      USER_ROUTES.Product.Testing.Tocc.Path
                    ) ||
                    $route.path.includes(USER_ROUTES.Product.Testing.Kat.Path),
                }"
              >
                <n-dropdown
                  trigger="hover"
                  placement="bottom-start"
                  :options="surveyOpt"
                  @select="handleSelect"
                  class="custom-dropdown-style"
                >
                  <router-link :to="`${USER_ROUTES.Product.Testing.Putt.Path}`"
                    >진단검사
                  </router-link>
                </n-dropdown>
              </li>
              <li
                role="toggle"
                :class="{
                  on:
                    $route.path.includes(
                      USER_ROUTES.Product.Coaching.Putt.Path
                    ) ||
                    $route.path.includes(
                      USER_ROUTES.Product.Coaching.Tocc.Path
                    ),
                }"
              >
                <n-dropdown
                  trigger="hover"
                  placement="bottom-start"
                  :options="coachOpt"
                  @select="handleSelect"
                  class="custom-dropdown-style"
                >
                  <router-link :to="`${USER_ROUTES.Product.Coaching.Putt.Path}`"
                    >상담코칭
                  </router-link>
                </n-dropdown>
              </li>
              <li
                role="toggle"
                :class="{
                  on:
                    $route.path.includes(
                      USER_ROUTES.Product.Activity.Talent.Path
                    ) ||
                    $route.path.includes(
                      USER_ROUTES.Product.Activity.Startup.Path
                    ) ||
                    $route.path.includes(
                      USER_ROUTES.Product.Activity.Career.Path
                    ) ||
                    $route.path.includes(
                      USER_ROUTES.Product.Activity.Growth.Path
                    ),
                }"
              >
                <n-dropdown
                  trigger="hover"
                  placement="bottom-start"
                  :options="activityOpt"
                  @select="handleSelect"
                  class="custom-dropdown-style"
                >
                  <router-link
                    :to="`${USER_ROUTES.Product.Activity.Talent.Path}`"
                    >Activity
                  </router-link>
                </n-dropdown>
              </li>
              <li
                role="toggle"
                :class="{
                  on:
                    $route.path.includes(
                      USER_ROUTES.Product.Expert.Expert.Path
                    ) ||
                    $route.path.includes(USER_ROUTES.Product.Expert.Cert.Path),
                }"
              >
                <n-dropdown
                  trigger="hover"
                  placement="bottom-start"
                  :options="eduOpt"
                  @select="handleSelect"
                  class="custom-dropdown-style"
                >
                  <router-link :to="`${USER_ROUTES.Product.Expert.Expert.Path}`"
                    >전문가교육
                  </router-link>
                </n-dropdown>
              </li>
              <li
                :class="{
                  on:
                    $route.path.includes(USER_ROUTES.Price.Org.Path) ||
                    $route.path.includes(USER_ROUTES.Price.Org.Test.Path) ||
                    $route.path.includes(USER_ROUTES.Price.Org.Activity.Path) ||
                    $route.path.includes(USER_ROUTES.Price.Org.Expert.Path),
                }"
              >
                <router-link :to="`${USER_ROUTES.Price.Org.Path}`"
                  >기관신청
                </router-link>
              </li>
            </ul>
            <!-- // 1 Depth -->
          </div>
        </div>
        <!-- //pc 메뉴 -->

        <!-- 모바일 메뉴 버튼  -->

        <a
          @click="toggleMenuBtn"
          class="icon-menu toggleGnb dis_mobile"
          :class="['icon-menu toggleGnb dis_mobile', { on: menuClicked }]"
          alt="모바일 메뉴버튼"
          ><n-icon><Menu /></n-icon
        ></a>
        <!-- //모바일 메뉴 버튼 -->

        <!-- 모바일 전화 버튼  -->
        <a
          href="javascript:alert('전화연결은 스마트폰에서만 가능합니다.');"
          class="icon-phone m_tel dis_mobile"
          ><n-icon style="transform: rotateY(3.142rad)"><Call /></n-icon
        ></a>
        <!-- //모바일 전화 버튼 -->

        <!-- 모바일 메뉴 -->
        <div id="mo_nav" :class="['mo_nav dis_mobile', { on: menuClicked }]">
          <!-- ***템플릿 호환가능*** (phpx 변수관리 추가 해주세요)-->

          <div
            id="pm_mo_nav_01"
            class="pm-navigation_vertical_toggle_mo_nav_01"
          >
            <!-- 1 Depth -->
            <ul class="dep1">
              <li role="toggle" :class="{ active: activeIndex === 0 }">
                <a @click="toggleMenu(0)"> CreateX소개 </a>

                <div
                  :class="['menuContent', { contentActive: activeIndex === 0 }]"
                >
                  <!-- 2 Depth -->
                  <ul class="dep2">
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Intro.Path}`"
                        @click="inactivateMenu"
                      >
                        CreateX 소개
                      </router-link>
                    </li>
                  </ul>
                  <!-- // 2 Depth -->
                </div>
              </li>
              <li role="toggle" :class="{ active: activeIndex === 1 }">
                <a @click="toggleMenu(1)"> 진단검사 </a>

                <div
                  :class="['menuContent', { contentActive: activeIndex === 1 }]"
                >
                  <!-- 2 Depth -->
                  <ul class="dep2">
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Product.Testing.Putt.Path}`"
                        @click="inactivateMenu"
                      >
                        PUTT2.0 다중재능검사
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Product.Coaching.Tocc.Path}`"
                        @click="inactivateMenu"
                      >
                        TOCC창의역량검사
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Product.Testing.Kat.Path}`"
                        @click="inactivateMenu"
                      >
                        KAT지식통각검사
                      </router-link>
                    </li>
                  </ul>
                  <!-- // 2 Depth -->
                </div>
              </li>
              <li role="toggle" :class="{ active: activeIndex === 2 }">
                <a @click="toggleMenu(2)"> 상담코칭 </a>

                <div
                  :class="['menuContent', { contentActive: activeIndex === 2 }]"
                >
                  <!-- 2 Depth -->
                  <ul class="dep2">
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Product.Coaching.Putt.Path}`"
                        @click="inactivateMenu"
                      >
                        PUTT2.0_학습진로상담코칭
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Product.Coaching.Tocc.Path}`"
                        @click="inactivateMenu"
                      >
                        TOCC_학습진로상담코칭
                      </router-link>
                    </li>
                  </ul>
                  <!-- // 2 Depth -->
                </div>
              </li>
              <li role="toggle" :class="{ active: activeIndex === 3 }">
                <a @click="toggleMenu(3)"> Activity </a>
                <div
                  :class="['menuContent', { contentActive: activeIndex === 3 }]"
                >
                  <!-- 2 Depth -->
                  <ul class="dep2">
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Product.Activity.Talent.Path}`"
                        @click="inactivateMenu"
                      >
                        재능진로전공직업 탐색 프로젝트
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Product.Activity.Startup.Path}`"
                        @click="inactivateMenu"
                      >
                        꿈 창업 프로젝트
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Product.Activity.Career.Path}`"
                        @click="inactivateMenu"
                      >
                        데이터 사이언스 체험 활동
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Product.Activity.Growth.Path}`"
                        @click="inactivateMenu"
                      >
                        성장–폴리오 과정
                      </router-link>
                    </li>
                  </ul>
                  <!-- // 2 Depth -->
                </div>
              </li>
              <li role="toggle" :class="{ active: activeIndex === 4 }">
                <a @click="toggleMenu(4)"> 전문가교육 </a>
                <div
                  :class="['menuContent', { contentActive: activeIndex === 4 }]"
                >
                  <!-- 2 Depth -->
                  <ul class="dep2">
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Product.Expert.Expert.Path}`"
                        @click="inactivateMenu"
                      >
                        전문가 과정
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="`${USER_ROUTES.Product.Expert.Cert.Path}`"
                        @click="inactivateMenu"
                      >
                        자격증 관리
                      </router-link>
                    </li>
                  </ul>
                  <!-- // 2 Depth -->
                </div>
              </li>
              <li>
                <router-link
                  :to="`${USER_ROUTES.Price.Org.Path}`"
                  @click="inactivateMenu"
                >
                  기관신청
                </router-link>
              </li>
            </ul>
            <!-- // 1 Depth -->
          </div>
        </div>
        <!-- //모바일 메뉴 -->
      </div>
    </div>
    <!-- //상단 로고 영역 -->
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onBeforeUnmount, watch } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { NDropdown, NIcon } from "naive-ui";
import { Call, Menu } from "@vicons/ionicons5";
import * as common from "@/assets/common/common"; // common.ts 파일이 있다면
import { useAuth } from "@/composables/useAuth";
import { firebaseAuth, getCallable } from "@/config/env";

const store = useStore();
const router = useRouter();
const route = useRoute();

const menuClicked = ref(false);
const nDropOprionProps = {
  style: {
    color: "#fff",
  },
};
const createXOpt = ref([
  {
    label: "CreateX 소개",
    key: USER_ROUTES.Intro.Path,
    props: nDropOprionProps,
  },
]);
const surveyOpt = ref([
  {
    label: "PUTT2.0 다중재능검사",
    key: USER_ROUTES.Product.Testing.Putt.Path,
    props: nDropOprionProps,
  },
  {
    label: "TOCC창의역량검사",
    key: USER_ROUTES.Product.Testing.Tocc.Path,
    props: nDropOprionProps,
  },
  {
    label: "KAT지식통각검사",
    key: USER_ROUTES.Product.Testing.Kat.Path,
    props: nDropOprionProps,
  },
]);
const coachOpt = ref([
  {
    label: "PUTT2.0_학습진로상담코칭",
    key: USER_ROUTES.Product.Coaching.Putt.Path,
    props: nDropOprionProps,
  },
  {
    label: "TOCC_학습진로상담코칭",
    key: USER_ROUTES.Product.Coaching.Tocc.Path,
    props: nDropOprionProps,
  },
]);
const activityOpt = ref([
  {
    label: "재능진로전공직업 탐색 프로젝트",
    key: USER_ROUTES.Product.Activity.Talent.Path,
    props: nDropOprionProps,
  },
  {
    label: "꿈 창업 프로젝트",
    key: USER_ROUTES.Product.Activity.Startup.Path,
    props: nDropOprionProps,
  },
  {
    label: "데이터 사이언스 체험 활동",
    key: USER_ROUTES.Product.Activity.Career.Path,
    props: nDropOprionProps,
  },
  {
    label: "성장–폴리오 과정",
    key: USER_ROUTES.Product.Activity.Growth.Path,
    props: nDropOprionProps,
  },
]);
const eduOpt = ref([
  {
    label: "전문가 과정",
    key: USER_ROUTES.Product.Expert.Expert.Path,
    props: nDropOprionProps,
  },
  {
    label: "자격증 관리",
    key: USER_ROUTES.Product.Expert.Cert.Path,
    props: nDropOprionProps,
  },
]);

const isScrolled = ref(false);
const activeIndex = ref<number | null>(null);

watch(route, () => {
  inactivateMenu();
});

function handleSelect(key: string) {
  router.push(`${key}`);
}

function handleScroll() {
  isScrolled.value = window.scrollY > 0;
}

function toggleMenuBtn() {
  menuClicked.value = !menuClicked.value;
  activeIndex.value = null;
}

function toggleMenu(idx: number) {
  if (idx === activeIndex.value) {
    activeIndex.value = null;
  } else {
    activeIndex.value = idx;
  }
}

function inactivateMenu() {
  menuClicked.value = false;
  activeIndex.value = null;
}

const {
  loading,
  isLoggedIn,
  loggedInUserId,
  handleLogout,
  isOrgUser,
  isOrgAdmin,
} = useAuth();

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});
</script>

<style>
.pm-navigation_horizon_pc_nav_02 .dep1 > li.on > a,
.pm-navigation_horizon_pc_nav_02 .dep1 > li.active > a,
.pm-navigation_horizon_pc_nav_02 .dep1 > li:hover > a {
  color: #c29c6b;
}

.menuContent {
  max-height: 0px;
  overflow: hidden;
  transition: all 0.4s ease-in-out;
}

.contentActive {
  max-height: 300px !important;
}

/* 드롭다운 패널의 배경색 설정 */
.custom-dropdown-style {
  background-color: #7d4d2a !important;
}
.custom-dropdown-style
  .n-dropdown-option
  .n-dropdown-option-body--pending:hover {
  --n-option-color-hover: #b08d66 !important;
}
</style>
